/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_EigenInputs */

const nl_planning_vakanties_eigen = /** @type {(inputs: Planning_Vakanties_EigenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigen vrije dagen`)
};

/**

* @param {Planning_Vakanties_EigenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_eigen = /** @type {((inputs?: Planning_Vakanties_EigenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_EigenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_eigen(inputs)
});
export { planning_vakanties_eigen as "planning.vakanties.eigen" }